import type { QueryClient } from '@tanstack/react-query';
import { Link, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { Button, EmptyState, Toaster, TooltipProvider } from '@/components/ui';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: ({ error }) => (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        title="Something went wrong"
        description={error instanceof Error ? error.message : 'An unexpected error occurred.'}
        action={<Button onClick={() => window.location.reload()}>Reload</Button>}
      />
    </div>
  ),
});

function Root() {
  return (
    <TooltipProvider delayDuration={350} skipDelayDuration={200}>
      <Outlet />
      <Toaster />
    </TooltipProvider>
  );
}

function NotFound() {
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        icon={<Compass />}
        title="Page not found"
        description="This page does not exist, or you do not have access to it."
        action={
          <Button asChild variant="primary">
            <Link to="/">Go home</Link>
          </Button>
        }
      />
    </div>
  );
}
